// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"PaymentErrorDialog_errorMessage__112di"};